const scrollIt = () => {
	var headerOffset = 0,
		$ahref = $('[href*="#"].scroll-it'),
		$html = $('html, body');
	if (Modernizr.mq('(min-width: 768px)')) headerOffset = 115;
	$ahref.click(function () {
		$html.animate(
			{
				scrollTop: $($.attr(this, 'href')).offset().top - headerOffset,
			},
			500
		);
		return false;
	});
};

const scrollUp = () => {
	var $scrollToTop = $('.scroll-to-top');

	$(window).on(
		'scroll',
		_.debounce(function () {
			if ($(this).scrollTop() > 50) {
				$scrollToTop.attr('aria-hidden', 'false');
				$scrollToTop.fadeIn();
			} else {
				$scrollToTop.attr('aria-hidden', 'true');
				$scrollToTop.fadeOut();
			}
		}, 300)
	);
	//Click event to scroll to top
	$scrollToTop.click(function () {
		doScrollToTop();
	});
};

const doScrollToTop = (passedScrollTop) => {
	var $htmlBody = $('html, body'),
		scrollTopToDo = 0;
	if (typeof passedScrollTop != 'undefined') scrollTopToDo = passedScrollTop;
	$htmlBody.animate(
		{
			scrollTop: scrollTopToDo,
		},
		800
	);

	if (document.getElementById('skipNavLink')) {
		document.getElementById('skipNavLink').classList.add('skipNavFocus');
		setTimeout(() => {
			document.getElementById('skipNavLink').focus();
		}, 0);

		document.getElementById('skipNavLink').addEventListener('focusout', (event) => {
			document.getElementById('skipNavLink').classList.remove('skipNavFocus');
		});
	}
	return false;
};

const windowLogoScroll = () => {
	$(window).on('scroll', function () {
		const siteSearch = document.querySelector('.site-search');
		var scrollPosition = $(window).scrollTop(),
			$htmlNoTouch = $('html.no-touchevents'),
			$myDillardsLogo = $('.myDillardsLogo'),
			$stickyNavBg = $('.sticky-nav-bg');
		if ($htmlNoTouch.length > 0 && $myDillardsLogo.length > 0 && $stickyNavBg.length > 0) {
			scrollPosition > 55 ? $myDillardsLogo.fadeIn() : $myDillardsLogo.fadeOut();
			scrollPosition > 0 && siteSearch.getBoundingClientRect().top <=1 ? $stickyNavBg.css('display', 'block') : $stickyNavBg.css('display', 'none');
		}
	});
};

export { scrollIt, scrollUp, doScrollToTop, windowLogoScroll };
